import axios from "axios";
import { GURL } from "./global";

export const GetAllProvinces = () => {
  const url = `${GURL}/Notice/v1/Province`;
  //console.log(url);
  return axios.get(url);
};
export const GetAllCitiesByProvinceId = (id: any) => {
  const url = `${GURL}/Notice/v1/Province/GetAllCities/${id}?provinceId=${id}`;
  //console.log(url);
  return axios.get(url);
};

export const AddNoticeLevelChangeApi = (
  noticeLevelId: any,
  groupId: any,
  userId: any,
  positionId: any,
  isValid: any
) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const url = `${GURL}/Messaging/v1/Groups/AddNoticeLevelChange`;
  return axios.post(url, {
    noticeLevelId,
    groupId,
    userId,
    positionId,
    isValid,
  });
};
export const AddNoticeDetailsAnswereApi = (
  vat: any,
  totalPrice: any,
  totalVat: any,
  totalPriceWithVat: any,
  count: any,
  noticeDetailId: any,
  groupId: any,
  price: any,
  description: any,
  userId: any,
  positionId: any,
  companyId: any
) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const url = `${GURL}/Messaging/v1/Groups/AddNoticeDetailsAnswere`;

  // console.log({
  //   vat,
  //   totalPrice,
  //   totalVat,
  //   totalPriceWithVat,
  //   count,
  //   noticeDetailId,
  //   groupId,
  //   price,
  //   description,
  //   userId,
  //   positionId,
  //   companyId,
  // });

  return axios.post(url, {
    vat,
    totalPrice,
    totalVat,
    totalPriceWithVat,
    count,
    noticeDetailId,
    groupId,
    price,
    description,
    userId,
    positionId,
    companyId,
  });
};

export const GetNoticeDetailsAnswere = (
  groupId: any
  //userId: any,
  //positionId: any
) => {
  const url = `${GURL}/Messaging/v1/Groups/GetNoticeDetailsAnswere?groupId=${groupId}`;
  //console.log(url);
  return axios.get(url);
};
export const GetGroupsByNoticeId = (noticeId: any) => {
  const url = `${GURL}/Messaging/v1/Groups/GetGroupsByNoticeId?noticeId=${noticeId}`;
  //console.log(url);
  return axios.get(url);
};

export const GetAllGroupsNoticesByPositionId = (positionId: any) => {
  const url = `${GURL}/Messaging/v1/Groups/GetAllGroupsNoticesByPositionId?positionId=${positionId}`;
  //console.log(url);
  return axios.get(url);
};

export const GetNoticeDetailsAnsweresTableByGroupId = (groupId: any) => {
  const url = `${GURL}/Messaging/v1/Groups/GetNoticeDetailsAnsweresTableByGroupId?groupId=${groupId}`;
  //console.log(url);
  return axios.get(url);
};
export const GetNoticeLevelChangesByGroupId = (groupId: any) => {
  const url = `${GURL}/Messaging/v1/Groups/GetNoticeLevelChangesByGroupId?groupId=${groupId}`;
  //console.log(url);
  return axios.get(url);
};

export const GetNoticeDetailsAnsweresForCompareByNoticeId = (NoticeId: any) => {
  const url = `${GURL}/Messaging/v1/Groups/GetNoticeDetailsAnsweresForCompareByGroupId?NoticeId=${NoticeId}`;
  //console.log(url);
  return axios.get(url);
};

export const GetNoticeDetailsAnsweresForCompareByGroupIdAndCompanyFilter = (
  NoticeId: any,
  CompanyIds: any
) => {
  //console.log("Call");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const url = `${GURL}/Messaging/v1/Groups/GetNoticeDetailsAnsweresForCompareByGroupIdAndCompanyFilter?NoticeId=${NoticeId}&CompanyIds=${CompanyIds}`;
  //console.log(url);
  return axios.get(url);
};
export const GetNoticeDetailAnswereTableByGroupIdWithCompanyFilter = (
  NoticeId: any,
  CompanyId: any
) => {
  //console.log("Call");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const url = `${GURL}/Messaging/v1/Groups/GetNoticeDetailAnswereTableByGroupIdWithCompanyFilter?groupId=${NoticeId}&CompanyId=${CompanyId}`;
  //console.log(url);
  return axios.get(url);
};

export const GetGroupIdByNoticeIdAndPositionId = (
  NoticeId: any,
  PositionId: any
) => {
  //console.log("Call");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const url = `${GURL}/Messaging/v1/Groups/GetGroupIdByNoticeIdAndPositionId?noticeId=${NoticeId}&positionId=${PositionId}`;
  //console.log(url);
  return axios.get(url);
};
